import { ForgotPasswordForm } from '@/v5/components/organisms/AuthForm/ForgotPasswordForm';
import { ChangePasswordForm } from '@/v5/components/organisms/AuthForm/ChangePasswordForm';
import { AuthTabs } from '@/v5/components/organisms/AuthTabs/AuthTabs';

function AuthContent({ isForgotPassword, isChangePassword }) {
    if (isForgotPassword) {
        return <ForgotPasswordForm />;
    } else if (isChangePassword) {
        return <ChangePasswordForm />;
    } else {
        return <AuthTabs />;
    }
}

export { AuthContent };
